import { Routes, Route, Navigate } from "react-router-dom";

import BrandLayout from "../layouts/BrandLayout";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import VerifyOTP from "../pages/auth/VerifyOTP";
import Profile from "../pages/screens/Profile";
import BrandCreatives from "../pages/brand/BrandCreatives";
import BrandCampaigns from "../pages/brand/BrandCampaigns";
import BrandReports from "../pages/brand/BrandReports";
import NotFound from "../pages/errors/NotFound";
import Unauthorized from "../pages/errors/Unauthorized";

/**
 * The brand portal's entire route tree. Admin routes are not registered here
 * at all, so on a dedicated brand build (REACT_APP_PORTAL=brand) none of them
 * are reachable. Note this is a UX boundary, not a security one — the backend
 * scopes every brand query from the auth context.
 */
const BrandRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/verify-otp" element={<VerifyOTP />} />

    <Route
      path="/"
      element={
        <ProtectedRoute>
          <BrandLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="/campaigns" replace />} />
      <Route
        path="creatives"
        element={
          <ProtectedRoute route="creatives">
            <BrandCreatives />
          </ProtectedRoute>
        }
      />
      {/*
        Campaigns is a read over the same creatives, so it is gated by the same
        `creatives` route permission — a brand that can see its creatives can
        see where they run.
      */}
      <Route
        path="campaigns"
        element={
          <ProtectedRoute route="creatives">
            <BrandCampaigns />
          </ProtectedRoute>
        }
      />
      {/*
        Reports read the same play logs as campaigns, so the same `creatives`
        route permission gates them — the backend pins the brand either way.
      */}
      <Route
        path="reports"
        element={
          <ProtectedRoute route="creatives">
            <BrandReports />
          </ProtectedRoute>
        }
      />
      <Route
        path="profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="/unauthorized" element={<Unauthorized />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default BrandRoutes;
